import { render, staticRenderFns } from "./OverlayMenu.vue?vue&type=template&id=6f2c7871&"
import script from "./OverlayMenu.vue?vue&type=script&lang=js&"
export * from "./OverlayMenu.vue?vue&type=script&lang=js&"
import style0 from "./OverlayMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports